
(function ($) {
    $(document).ready(function () {
        const $sliders = $('.posts-slider');
        if (!$sliders.length) return;
        $sliders.each(function () {
            const $slider = $(this);
            const slider_id = $slider.attr('id');
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }
            $slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        });
    });
})(jQuery);